export default __webpack_public_path__ + "static/media/p68.e414b0a7.jpg";